import { MASTER_LOCATION_DATA_LOCATION_KEY } from "../../../core/constants/erpConstants";

export const IP_BILLING_KEY = MASTER_LOCATION_DATA_LOCATION_KEY.IP_BILLING;
export const OP_BILLING_KEY = MASTER_LOCATION_DATA_LOCATION_KEY.OP_BILLING;

export const getInPatientLocationKey = () => IP_BILLING_KEY;
export const getOutPatientLocationKey = () => OP_BILLING_KEY;

/**
 * Resolve billing location key based on patient type.
 * - If patient is IP or Walk in -> IP_BILLING (IN-PATIENTS)
 * - If patient is Outpatient -> OP_BILLING (OUT_PATIENTS)
 * - If patient is not selected -> IP_BILLING (default)
 */
export const resolvePatientBillingLocationKey = (patient) => {
  if (!patient) return IP_BILLING_KEY;

  const visitType = (patient?.visit?.type || "").toLowerCase().trim();
  const visitFlag = (patient?.visit?.visitflag || patient?.visitflag || "").toLowerCase().trim();
  const pType = (patient?.type || patient?.patientType || "").toLowerCase().trim();

  const isWalkIn =
    visitFlag.includes("walk") ||
    pType.includes("walk") ||
    visitType.includes("walk");

  const isIP =
    visitType === "inpatient" ||
    visitType === "ip" ||
    pType === "inpatient" ||
    pType === "ip";

  const isOP =
    visitType === "outpatient" ||
    visitType === "op" ||
    pType === "outpatient" ||
    pType === "op";

  // When patient is IP or Walk in -> IN-PATIENTS
  if (isWalkIn || isIP) {
    return IP_BILLING_KEY;
  }

  // When patient is Outpatient -> OUT_PATIENTS
  if (isOP) {
    return OP_BILLING_KEY;
  }

  // Default: IN-PATIENTS
  return IP_BILLING_KEY;
};

/**
 * Filter billing locations:
 * - Excludes all, pharmacy, laboratory
 * - Only includes in-patients (IP_BILLING) and out-patients (OP_BILLING)
 */
export const getFilteredBillingLocations = (masterLocations) => {
  if (!masterLocations) {
    return [
      { locationKey: IP_BILLING_KEY, displayName: "IP BILLING" },
      { locationKey: OP_BILLING_KEY, displayName: "OP BILLING" },
    ];
  }

  const list = Array.isArray(masterLocations) ? masterLocations : [masterLocations];
  const filtered = list.filter((loc) => {
    if (!loc?.locationKey) return false;
    const key = loc.locationKey.toLowerCase().trim();
    if (
      key === MASTER_LOCATION_DATA_LOCATION_KEY.ALL ||
      key.endsWith("_all") ||
      key === MASTER_LOCATION_DATA_LOCATION_KEY.PHARMACY ||
      key === MASTER_LOCATION_DATA_LOCATION_KEY.LABORATORY
    ) {
      return false;
    }
    return key === IP_BILLING_KEY || key === OP_BILLING_KEY;
  });

  return filtered.length > 0
    ? filtered
    : [
        { locationKey: IP_BILLING_KEY, displayName: "IP BILLING" },
        { locationKey: OP_BILLING_KEY, displayName: "OP BILLING" },
      ];
};
